import React from 'react';
// @import components
import Slider from './slider';
import Table from 'components/table';
import SmallSlider from './SmallSlider';
// @import dependencies
import { useSelector } from 'react-redux';

const columns = [
  { title: 'Account', dataIndex: 'account', key: 'account' },
  {
    title: 'Available Balance',
    dataIndex: 'availableBalance',
    key: 'availableBalance',
  },
  {
    title: 'Current Balance',
    dataIndex: 'currentBalance',
    key: 'currentBalance',
  },
];

const column2 = [
  {
    title: 'Daily Credit Available',
    dataIndex: 'dailyCreditAvailableLimit',
    key: 'dailyCreditAvailableLimit',
  },
  {
    title: 'Daily Credit Remaining',
    dataIndex: 'dailyCreditRemainingLimit',
    key: 'dailyCreditRemainingLimit',
  },
  {
    title: 'Daily Debit Available',
    dataIndex: 'dailyDebitAvailableLimit',
    key: 'dailyDebitAvailableLimit',
  },
  {
    title: 'Daily Debit Remaining',
    dataIndex: 'dailyDebitRemainingLimit',
    key: 'dailyDebitRemainingLimit',
  },
];

const LeftSide = () => {
  const { authData } = useSelector(state => state.auth);
  const { info } = useSelector(state => state.home);
  const { listMenus } = useSelector(state => state.commonState);

  return (
    <div className='rounded-[30px] border border-[#E7E7E9] bg-white'>
      <section className='px-[23px] py-[30px]'>
        {listMenus?.dashboardBanners ? (
          <Slider data={listMenus?.dashboardBanners} />
        ) : null}
        <div className='mt-2'>
          <p className='text-[28px] font-medium text-custom-dark'>
            Welcome {authData?.identity}
          </p>
          <p className='text-[16px] text-custom-dark opacity-70'>
            Your last login at 5:50 PM on Monday 23 January 2024
          </p>
        </div>
      </section>
      {info?.basicHandlerProfile ? (
        <Table
          search={false}
          columns={column2}
          data={[
            {
              dailyCreditAvailableLimit: info?.dailyCreditAvailableLimit,
              dailyCreditRemainingLimit: info?.dailyCreditRemainingLimit,
              dailyDebitAvailableLimit: info?.dailyDebitAvailableLimit,
              dailyDebitRemainingLimit: info?.dailyDebitRemainingLimit,
            },
          ]}
        />
      ) : (
        <Table
          search={false}
          data={[
            {
              account: authData?.identity,
              availableBalance: info?.availableBalance || 0,
              currentBalance: info?.currentBalance || 0,
            },
          ]}
          columns={columns}
        />
      )}
      <div className='w-full bg-[#E7E7E9]'>
        <p className='py-2 pl-6 text-[14px] font-[700]'>
          Current Balance : {info?.currentBalance || 0}
        </p>
      </div>

      {listMenus?.dashboardImages ? (
        <SmallSlider data={listMenus?.dashboardImages} />
      ) : null}
    </div>
  );
};

export default LeftSide;
